module.exports = __webpack_public_path__ + "img/mysql-logo.5665032c.svg";